(() => {
  const root = document.querySelector('[data-ledumi]');
  if (!root) return;
  const format = (cents) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: window.Shopify?.currency?.active || 'PLN' }).format(cents / 100);
  let quantity = 2;
  const variantInput = root.querySelector('[data-variant-select]');
  const activeVariant = () => {
    if (variantInput?.tagName === 'SELECT') return variantInput.options[variantInput.selectedIndex];
    return variantInput;
  };
  const update = () => {
    const option = activeVariant();
    const price = Number(option?.dataset.price || 0);
    const compare = Number(option?.dataset.compareValue || 0);
    const discount = quantity === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
    const total = Math.max(0, price * quantity - discount);
    root.querySelectorAll('[data-price-for]').forEach((node) => {
      const qty = Number(node.dataset.priceFor);
      const bundleDiscount = qty === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
      node.textContent = format(Math.max(0, price * qty - bundleDiscount));
    });
    root.querySelectorAll('[data-compare-for]').forEach((node) => {
      const qty = Number(node.dataset.compareFor);
      const compareTotal = compare * qty;
      const bundleDiscount = qty === 2 ? Number(root.dataset.bundleDiscount || 0) : 0;
      const saleTotal = Math.max(0, price * qty - bundleDiscount);
      node.textContent = compareTotal > saleTotal ? format(compareTotal) : '';
      node.hidden = compareTotal <= saleTotal;
    });
    root.querySelector('[data-total]').textContent = format(total);
    root.querySelectorAll('[data-mobile-total]').forEach((node) => { node.textContent = format(total); });
    const del = root.querySelector('del[data-compare]');
    del.textContent = compare * quantity > total ? format(compare * quantity) : '';
    del.hidden = compare * quantity <= total;
  };
  root.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
    quantity = Number(button.dataset.qty);
    root.querySelectorAll('[data-qty]').forEach((item) => {
      item.classList.toggle('selected', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    update();
  }));
  variantInput?.addEventListener('change', update);
  root.querySelectorAll('[data-thumb]').forEach((button) => button.addEventListener('click', () => {
    root.querySelector('[data-main-image]').src = button.dataset.thumb;
    root.querySelectorAll('[data-thumb]').forEach((item) => item.classList.toggle('active', item === button));
  }));
  const drawer = root.querySelector('[data-drawer]');
  const overlay = root.querySelector('[data-overlay]');
  const close = () => { drawer.classList.remove('open'); overlay.classList.remove('open'); };
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const renderCart = async () => {
    const response = await fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    const lines = root.querySelector('[data-cart-lines]'); lines.replaceChildren();
    cart.items.forEach((item, index) => {
      const row = document.createElement('div'); row.className = 'drawer-line';
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; row.append(img); }
      const text = document.createElement('span'); text.className = 'drawer-line-title'; text.textContent = `${item.product_title} × ${item.quantity}`; row.append(text);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'cart-remove'; remove.dataset.removeCartLine = String(index + 1); remove.textContent = 'Usuń'; remove.setAttribute('aria-label', `Usuń ${item.product_title} z koszyka`); row.append(remove);
      lines.append(row);
    });
    root.querySelector('[data-cart-total]').textContent = format(cart.total_price);
    root.querySelector('[data-cart-empty]').hidden = cart.items.length > 0;
    root.querySelector('[data-cart-actions]').hidden = cart.items.length === 0;
    root.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    return cart;
  };
  const updateCart = async (path, body = {}) => {
    const response = await fetch(`${cartRoot()}cart/${path}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Nie udało się zaktualizować koszyka.');
    await renderCart();
  };
  const openCart = async () => {
    drawer.classList.add('open'); overlay.classList.add('open');
    try {
      await renderCart();
    } catch (error) {
      root.querySelector('[data-cart-lines]').textContent = error.message;
    }
  };
  root.querySelector('[data-cart-lines]')?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-remove-cart-line]');
    if (!button) return;
    button.disabled = true;
    try {
      await updateCart('change', { line: Number(button.dataset.removeCartLine), quantity: 0 });
    } catch (error) {
      window.alert(error.message);
      button.disabled = false;
    }
  });
  root.querySelector('[data-cart-clear]')?.addEventListener('click', async (event) => {
    if (!window.confirm('Usunąć wszystkie produkty z koszyka?')) return;
    const button = event.currentTarget; button.disabled = true;
    try {
      await updateCart('clear');
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
    }
  });
  root.querySelector('[data-cart-open]')?.addEventListener('click', openCart);
  root.querySelector('[data-cart-close]')?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  const existingCartModal = root.querySelector('[data-existing-cart-modal]');
  const existingCartItems = root.querySelector('[data-existing-cart-items]');
  let pendingPurchaseButton = null;
  const closeExistingCartModal = () => {
    existingCartModal.hidden = true;
    if (pendingPurchaseButton) {
      pendingPurchaseButton.disabled = false;
      pendingPurchaseButton.focus();
      pendingPurchaseButton = null;
    }
  };
  const startCheckout = async (clearExisting = false) => {
    const button = pendingPurchaseButton;
    if (!button) return;
    existingCartModal.hidden = true;
    try {
      if (clearExisting) await updateCart('clear');
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(activeVariant().value), quantity }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Nie udało się dodać produktu.');
      window.location.assign(root.dataset.checkout || `${cartRoot()}checkout`);
    } catch (error) {
      pendingPurchaseButton = null;
      button.disabled = false;
      window.alert(error.message);
    }
  };
  root.querySelectorAll('[data-existing-cancel]').forEach((button) => button.addEventListener('click', closeExistingCartModal));
  root.querySelector('[data-existing-clear]')?.addEventListener('click', () => startCheckout(true));
  root.querySelector('[data-existing-keep]')?.addEventListener('click', () => startCheckout(false));
  existingCartModal?.addEventListener('click', (event) => {
    if (event.target === existingCartModal) closeExistingCartModal();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !existingCartModal.hidden) closeExistingCartModal();
  });
  root.querySelectorAll('[data-add]').forEach((addButton) => addButton.addEventListener('click', async (event) => {
    const button = event.currentTarget; button.disabled = true;
    try {
      const response = await fetch(`${cartRoot()}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Nie udało się sprawdzić koszyka.');
      pendingPurchaseButton = button;
      if (cart.item_count > 0) {
        existingCartItems.replaceChildren();
        cart.items.forEach((item) => {
          const row = document.createElement('li');
          row.textContent = `${item.product_title} × ${item.quantity}`;
          existingCartItems.append(row);
        });
        existingCartModal.hidden = false;
        root.querySelector('[data-existing-clear]').focus();
        return;
      }
      await startCheckout(false);
    } catch (error) {
      pendingPurchaseButton = null;
      button.disabled = false;
      window.alert(error.message);
    }
  }));
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealTargets = root.querySelectorAll('.hero-photo, .buybox, .moments, .guarantee, .steps, .split, .formats, .faq, .final-cta');
    revealTargets.forEach((element) => element.classList.add('scroll-reveal'));
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealTargets.forEach((element) => revealObserver.observe(element));
  }
  update();
})();
